/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Error for when there's an issue getting a response from the smarts service
 * @param {object} options
 * @param {string} options.requestName - name of smarts request
 * @param {string} options.responseMessage - description of error from http response / smarts payload
 * @param {string} [options.httpCode] - in case of http error, the error code
 * @param {string} [options.smartsCode] - in case of smarts service error, the smarts error code
 */
function SmartsRecommenderError(options) {
	this.name = 'SmartsRecommenderError';
	this.message = options.message || `Error executing ${options.requestName} - ${options.httpCode || options.smartsCode}: ${options.responseMessage}`;

	this.requestName = options.requestName;
	this.httpCode = options.httpCode;
	this.smartsCode = options.smartsCode;
	this.responseMessage = options.responseMessage;
}

SmartsRecommenderError.prototype = Object.create(Error.prototype);

SmartsRecommenderError.prototype.setUserStrings = function(title, message, suggestions) {
	this.userTitle = title;
	this.userMessage = message;
	this.suggestions = suggestions;
};

SmartsRecommenderError.prototype.getUserStrings = function() {
	return (this.userTitle || this.userMessage || this.suggestions) ?
		{
			title: this.userTitle,
			message: this.userMessage,
			suggestions: this.suggestions
		} : null;
};

export default SmartsRecommenderError;



// WEBPACK FOOTER //
// ./src/js/util/SmartsRecommenderError.js